import React, { useEffect, useMemo, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import useSearch from "hooks/useSearch"
import useReportColumns from "hooks/useReportColumns"
import { REPORT_COLUMN_KEYS } from "config/reportColumnDefinitions"
import MonitorReceiptReportListComponent from "components/MonitorReports/Receipt"
import {
  exportMonitorReceiptReport,
  getMonitorReceiptReports,
} from "store/monitor-reports/monitor-report-action"
import {
  getMonitorIps,
  getMonitorItemCategories,
  getMonitorWarehouses,
} from "store/monitor-dashboard/monitor-dashboard-action"

const MonitorReceiptReportList = () => {
  document.title = "Receipt Reports"

  const dispatch = useDispatch()

  // Retrieve receipts data from Redux store
  const receipts = useSelector(
    state => state.monitorReports.monitorReceiptsReport
  )

  // Current status of the export process for the consumption report, retrieved from the Redux store
  const exportStatus = useSelector(
    state => state.monitorReports.monitorExportReceiptReport
  )
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(20)
  const [according, setAccording] = useState({ order: "desc", name: "date" })
  const [advnacedSearch, setAdvancedSearch] = useState({})
  const { columns, visibleColumns, visibleKeys, toggleColumn, moveColumnToIndex } = useReportColumns(
    REPORT_COLUMN_KEYS.MONITOR_RECEIPT
  )


  // Updates search value when a new search is performed
  const onSearchHandler = value => {
    setSearch(value)
  }

  // Fetches new activity logs when a page number is clicked
  const onPageClick = link => {
    dispatch(
      getMonitorReceiptReports(
        link.url,
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }

  // Updates the number of rows displayed based on user selection (e.g., 10, 20, 50)
  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  // Updates the ordering based on user selection
  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  // Custom Search Hook called everytime search updates
  useSearch(
    getMonitorReceiptReports(
      undefined,
      undefined,
      undefined,
      search,
      advnacedSearch
    ),
    search
  )

  // fetch new data based page number or according changes
  useEffect(() => {
    dispatch(
      getMonitorReceiptReports(
        undefined,
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }, [pageNumber, according])

  // fetch needed data based filter select box
  useEffect(() => {
    dispatch(getMonitorItemCategories())
    dispatch(getMonitorWarehouses())
    dispatch(getMonitorIps())
  }, [])

  // Executes when the advanced search form is submitted
  const onAdvancedSearchSubmit = data => {
    setAdvancedSearch(data)
    dispatch(
      getMonitorReceiptReports(undefined, undefined, undefined, search, data)
    )
  }

  // Trigger export process when Export button is clicked
  const onExportBtnClick = () => {
    dispatch(exportMonitorReceiptReport(pageNumber, according, search, advnacedSearch, visibleKeys))
  }

  return (
    <React.Fragment>
      <Breadcrumbs title={"Monitor"} breadcrumbItem={"Receipt Reports"} />

      {/* Monitor Receipt Report Component  */}
      <MonitorReceiptReportListComponent
        data={receipts?.data}
        error={receipts?.error}
        loading={receipts?.loading}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
        onAdvancedSearchSubmit={onAdvancedSearchSubmit}
        onExportBtnClick={onExportBtnClick}
        exportStatus={exportStatus}
        onPageClick={onPageClick}
        columns={columns}
        visibleColumns={visibleColumns}
        onToggleColumn={toggleColumn}
        onReorder={moveColumnToIndex}
      />
    </React.Fragment>
  )
}

export default MonitorReceiptReportList
